module.exports = __webpack_public_path__ + "static/media/imgGalleryM1.20f5d6e5.svg";